import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { DATE_FORMAT_CLIENT_PARAMS, DATE_TIME_FORMAT_CLIENT, getStatusOrder, ROLES } from '../../helpers/constants'
import { useTranslation } from 'react-i18next'
import { Button, Space } from 'antd'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
// @ts-ignore
import ReactExport from 'react-data-export'
import moment from 'moment'
import { useRef, useState } from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import * as XLSX from 'xlsx'
import { cloneDeep, groupBy, isError, reduce, set } from 'lodash'
import PreviewFileImport from './PreviewFileImport'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const ExportToCSV = observer((props: any) => {
   const {
      from: fromDate,
      to: toDate,
      getData,
      hideExport = false,
      importButtonText = 'Nhập Excel',
      importMode = 'order'
   } = props
   const { t } = useTranslation()
   const AuthStore = useStore('AuthStore')
   const { data_getUserInfo } = AuthStore
   const OrdersStore = useStore('OrdersStore')
   const { rows } = OrdersStore.dataExport
   const exportRef = useRef(null)
   const inputFileRef = useRef(null)
   const [visiblePreviewImport, setVisiblePreviewImport] = useState(false)
   const [selectedRow, setSelectedRow] = useState<any[]>([])
   const [dataInsert, setDataInsert] = useState<any>(null)

   const handleExportData = async () => {
      try {
         const from = moment(fromDate).format(DATE_FORMAT_CLIENT_PARAMS)
         const to = moment(toDate).format(DATE_FORMAT_CLIENT_PARAMS)

         await OrdersStore.exportExcel({ from, to })
         if (exportRef.current !== null) {
            // @ts-ignore
            exportRef.current!.click()
         }
      } catch (error) {}
   }

   const handleInputFile = () => {
      if (inputFileRef.current !== null) {
         // @ts-ignore
         inputFileRef.current!.click()
      }
   }

   const handleImportCSV = async (event: any) => {
      const file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = async (e: any) => {
         const data = new Uint8Array(e.target.result)
         const workbook = XLSX.read(data, { type: 'array' })
         const sheetName = workbook.SheetNames[0]
         const rawWorksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
            header: [
               'sellerOrderId',
               'sku',
               'qty',
               'linkMockup',
               'linkDesign',
               'note',
               'trackingId',
               'shipLabel',
               'customer',
               'email',
               'phone',
               'country',
               'state',
               'address1',
               'address2',
               'city',
               'zipCode'
            ],
            raw: false,
            defval: ''
         })

         // Xử lý từng dòng để thay thế null/undefined bằng chuỗi rỗng
         const worksheet = rawWorksheet.map((row: any) => {
            const processedRow = {} as any
            Object.keys(row).forEach((key) => {
               processedRow[key] = row[key] === null || row[key] === undefined ? '' : row[key]
            })
            return processedRow
         })
         worksheet.splice(0, 1) // Xóa dòng tiêu đề nếu có
         // setSelectedRow(cloneDeep(worksheet))
         console.log('====================================')
         console.log('dataRows', worksheet)
         console.log('====================================')
         let dataRows = cloneDeep(worksheet) as any[]
         const groupData = groupBy(worksheet, 'sellerOrderId')

         console.log('groupData', groupData)
         let dataConvert = [] as any[]
         Object.keys(groupData).forEach((key) => {
            const orders = groupData[key] as any[]
            const listProduct = orders.map((order: any) => ({
               id: order.sku,
               qty: order.qty
            }))

            delete (orders[0] as any).sku
            delete (orders[0] as any).qty

            dataConvert.push({ ...orders[0], listProduct })
         })
         setDataInsert(cloneDeep(dataConvert))

         const dataResponse = await OrdersStore.previewListOrder(dataConvert)

         if (dataResponse?.code == 200) {
            dataRows = dataRows.map((row: any) => {
               const found = dataResponse.data.find((d: any) => d.sellerOrderId == row.sellerOrderId)
               if (found && found?.isError) {
                  return {
                     ...row,
                     isError: true,
                     errorMessage: found.errorMessage
                  }
               }
               return row
            })
            setSelectedRow(dataRows as any[])

            console.log('dataRowsdataRowsdataRows', dataRows)
         }

         setVisiblePreviewImport(true)

         // OrdersStore.setOrderList(worksheet)
      }
      reader.readAsArrayBuffer(file)
   }

   console.log('====================================')
   console.log('rows', rows)
   console.log('====================================')

   const exportToCSV = () => {
      return (
         <ExcelFile
            element={
               <Button ref={exportRef}>
                  {t(GLOBAL_CLIENT.exportCSV)}
                  <DownloadOutlined />
               </Button>
            }
            filename={`Đơn đặt hàng ${moment().format('HH:mm:ss DD-MM-YYYY')}`}
         >
            <ExcelSheet com data={rows} name="PurchaseOrderManagement">
               <ExcelColumn label={'OrderID'} value="id" />
               <ExcelColumn
                  label={'Ngày tạo'}
                  value={(col: any) => moment(col?.createdAt).format(DATE_TIME_FORMAT_CLIENT)}
               />
               <ExcelColumn label={'Seller OrderID'} value="sellerOrderId" />
               <ExcelColumn
                  label={'Product SKU'}
                  value={(col: any) => {
                     console.log(col)

                     return (col?.products_orders || []).map((po: any) => po?.product?.name).join(', ')
                  }}
               />
               <ExcelColumn
                  label={'QTY'}
                  value={(col: any) =>
                     (col?.products_orders || []).reduce((sum: number, po: any) => sum + (po?.qty || 0), 0)
                  }
               />
               <ExcelColumn
                  label={'Services'}
                  value={(col: any) =>
                     (col?.service_orders || [])
                        .map((so: any) => (so?.qty > 1 ? `${so?.serviceName} x${so?.qty}` : so?.serviceName))
                        .join(', ')
                  }
               />
               <ExcelColumn label={'Ship to'} value="shipLabel" />
               <ExcelColumn label={'Seller note'} value="shipLabel" />
               <ExcelColumn label={'Base cost'} value="totalPrice" />
               <ExcelColumn label={'Shipping cost'} value="shippingFee" />
               <ExcelColumn label={'Total'} value="subTotalPrice" />
               <ExcelColumn label={'Seller'} value={(col: any) => col?.account?.name || ''} />
               <ExcelColumn label={'Tracking ID'} value="trackingId" />
               <ExcelColumn label={'Status tracking'} value="trackingStatus" />
               <ExcelColumn label={'Status order'} value={(col: any) => getStatusOrder(col?.status, col)}  />
               <ExcelColumn label={'Note'} value="note" />
               <ExcelColumn label={'Note1'} value="note1" />
               <ExcelColumn label={'DVVC'} value="deliveryPartner" />
               <ExcelColumn
                  label={'LinkMockup'}
                  value={(col: any) => {
                     let value = col?.products_orders.map((v: any) => v?.linkMockup || '').join('\n')
                     if (value) {
                        return value
                     } else {
                        return col?.linkMockup || ''
                     }
                  }}
               />
               <ExcelColumn
                  label={'LinkDesign'}
                  value={(col: any) => {
                     let value = col?.products_orders.map((v: any) => v?.linkDesign || '').join('\n')
                     if (value) {
                        return value
                     } else {
                        return col?.linkDesign || ''
                     }
                  }}
               />
            </ExcelSheet>
         </ExcelFile>
      )
   }
   return (
      <Space>
         <Button className="btn-add" onClick={handleInputFile}>
            {importButtonText}
         </Button>
         {!hideExport && (data_getUserInfo?.role == ROLES.ADMIN || data_getUserInfo?.role == ROLES.MANAGER_ORDER) && (
            <Button onClick={handleExportData}>
               {t(GLOBAL_CLIENT.exportExcel)}
               <DownloadOutlined />
            </Button>
         )}
         <div style={{ display: 'none' }}>
            <input ref={inputFileRef} type="file" accept=".xlsx, .xls" onChange={handleImportCSV} />
            {exportToCSV()}
         </div>
         {visiblePreviewImport && (
            <PreviewFileImport
               items={selectedRow}
               visible={visiblePreviewImport}
               onOk={() => {
                  setVisiblePreviewImport(false)
                  if (inputFileRef.current) {
                     ;(inputFileRef.current as HTMLInputElement).value = ''
                  }
                  getData?.()
               }}
               onCancel={() => {
                  setVisiblePreviewImport(false)
                  if (inputFileRef.current) {
                     ;(inputFileRef.current as HTMLInputElement).value = ''
                  }
               }}
               dataInsert={dataInsert}
               importMode={importMode}
            />
         )}
      </Space>
   )
})

export default ExportToCSV
